import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api-client"
import type { Notification, NotificationPreference } from "@/lib/types"

export function useNotifications() {
  return useQuery({
    queryKey: ["notifications"],
    queryFn: () => api.get<{ data: Notification[] }>("/api/v1/notifications"),
    refetchInterval: 60000, // Poll every 60 seconds
  })
}

export function useUnreadCount() {
  return useQuery({
    queryKey: ["notifications", "unread_count"],
    queryFn: () => api.get<{ count: number }>("/api/v1/notifications/unread_count"),
    refetchInterval: 30000, // Poll every 30 seconds
  })
}

export function useMarkNotificationRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.post(`/api/v1/notifications/${id}/read`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["notifications"] })
    },
  })
}

export function useMarkAllRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.post("/api/v1/notifications/read_all"),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["notifications"] })
    },
  })
}

export function useNotificationPreferences() {
  return useQuery({
    queryKey: ["notification_preferences"],
    queryFn: () => api.get<{ data: NotificationPreference[] }>("/api/v1/notifications/preferences"),
  })
}

export function useUpdateNotificationPreferences() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (prefs: NotificationPreference[]) =>
      api.put("/api/v1/notifications/preferences", { preferences: prefs }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["notification_preferences"] })
    },
  })
}
